import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { showingClosedFormSubmissions, showClosedSubmissions, showOpenSubmissions } from "reduxSlices/formSubmissionTableSlice"
import Switch from "shared/Switch"

const SubmissionClosedFilter = () => {
  const dispatch = useDispatch()
  const closedVisible = useSelector(showingClosedFormSubmissions)
  const reducer = closedVisible ? showOpenSubmissions : showClosedSubmissions
  const toggleFunction = () => dispatch(reducer())

  return (
    <div className="p-6 border-b border-lightgray-3">
      <div className="font-semibold flex-center">
        Show closed submissions
        <Switch
          checked={closedVisible}
          onChange={toggleFunction}
        />
      </div>
      <span className="text-xs text-dark">Previous month</span>
    </div>
  )
}

export default SubmissionClosedFilter
